import * as React from 'react';
export const cimbSvg = React.forwardRef(function cimbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#790008',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm21.251 6.972 6.75 9H12.75l-6.749-9h15.25Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm28 15.971-6.75 9H6l6.75-9H28Z',
      fill: '#ED1D24',
    }),
  );
});
cimbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cimb = {
  category: 'brand',
  colorable: false,
  name: 'cimb',
  svg: cimbSvg,
};
